import type { I18n } from 'utils/translations/translations';

function getConstraints({ i18n }: { i18n: I18n }) {
  return {
    firstName: {
      presence: {
        allowEmpty: false,
        message: `^${i18n.t('form.errors.required')}`,
      },
      customFormat: {
        pattern:
          '^[^\\p{Han}|\\p{Katakana}|\\p{Hiragana}|\\p{Hangul}|\\p{Arabic}]+$',
        message: `^${i18n.t('form.errors.invalid.characters')}`,
      },
    },
    lastName: {
      presence: {
        allowEmpty: false,
        message: `^${i18n.t('form.errors.required')}`,
      },
      customFormat: {
        pattern:
          '^[^\\p{Han}|\\p{Katakana}|\\p{Hiragana}|\\p{Hangul}|\\p{Arabic}]+$',
        message: `^${i18n.t('form.errors.invalid.characters')}`,
      },
    },
    email: {
      presence: {
        allowEmpty: false,
        message: `^${i18n.t('form.errors.required')}`,
      },
      email: {
        message: `^${i18n.t('form.errors.invalid')}`,
      },
    },
    password: {
      presence: {
        allowEmpty: false,
        message: `^${i18n.t('form.errors.required')}`,
      },
    },
    confirmPassword: {
      presence: {
        allowEmpty: false,
        message: `^${i18n.t('form.errors.required')}`,
      },
      equality: {
        attribute: 'password',
        message: `^${i18n.t('form.errors.passwords_dont_match')}`,
      },
    },
    terms: {
      presence: true,
      inclusion: {
        within: [true],
      },
    },
  };
}

export { getConstraints };
